<template>
  <div :class="`cnc-loading ${sizeLoading[size]} ${getOnColor} ${full &&'center2D position-fixed'}`" :data-qa="`${qa ? `loading-${qa}` : 'loading' }`">
    <div :class="`loader ${onColor ? 'on-color' : ''}`" :style="`width:${getWidth}px;padding:${getPadding}px`"></div>
    <div v-if="withText && size === 'large'" class="loading-text">Loading</div>
  </div>
</template>

<script>
export default {
  props: {
    size: { type: String, default: 'large' },
    withText: { type: Boolean },
    onColor: { type: Boolean },
    qa: { type: String },
    full: { type: Boolean }
  },
  data () {
    return {
      sizeLoading: {
        'large': 'loading-large',
        'small': 'loading-small'
      }
    }
  },
  computed: {
    getWidth () {
      if (this.size === 'large') return 40
      else return 24
    },
    getPadding () {
      if (this.size === 'large') return 6
      else return 4
    },
    getOnColor () {
      if (this.onColor) return 'loading-on-color'
      else return 'loading-on-base'
    }
  }
}
</script>

<style lang="scss">
.cnc-loading{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &.loading-large{
    .loading-text{
      font-size: 14px;
      margin-top: 8px;
      color: $color-cool-grey-500;
    }
  }

  &.loading-on-color{
    .loading-text{
      font-size: 14px;
      margin-top: 8px;
      color: $color-white;
    }
  }

  .loader {
    width: 50;
    padding: 8px;
    aspect-ratio: 1;
    border-radius: 50%;
    background: $color-cool-grey-500;
    --_m: conic-gradient(#0000 10%,#000),
      linear-gradient(#000 0 0) content-box;
    -webkit-mask: var(--_m);
            mask: var(--_m);
    -webkit-mask-composite: source-out;
            mask-composite: subtract;
    animation: l3 0.6s infinite linear;

    &.on-color {
      background: $color-white;
    }
  }
  @keyframes l3 {to{transform: rotate(1turn)}}
}
</style>
